export default __webpack_public_path__ + "static/media/pina_colada_slushie.ce638d76.JPG";